import * as tslib_1 from "tslib";
import * as React from "react";
var Footer = /** @class */ (function (_super) {
    tslib_1.__extends(Footer, _super);
    function Footer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Footer.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("footer", { className: "m-grid__item\t\tm-footer " },
                React.createElement("div", { className: "m-container m-container--fluid m-container--full-height m-page__container" },
                    React.createElement("div", { className: "m-stack m-stack--flex-tablet-and-mobile m-stack--ver m-stack--desktop" },
                        React.createElement("div", { className: "m-stack__item m-stack__item--left m-stack__item--middle m-stack__item--last" }))))));
    };
    return Footer;
}(React.Component));
export default Footer;



//////////////////
// WEBPACK FOOTER
// ./src/components/Footer.tsx
// module id = 313
// module chunks = 0